import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface OrderSelection {
  id: number
  orderCardId: number
  displayMemo: string
  editingSystemUserId: number
  selectionBranch: SystemCode
  orderNumber: number
  callNo: string
  shelfType: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
}

export function OrderSelectionFromJSON(json: any): OrderSelection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    orderCardId: exists(json, 'order_card_id') ? json.order_card_id : 0,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : 0,
    editingSystemUserId: exists(json, 'editing_system_user_id')
      ? json.editing_system_user_id
      : 0,
    selectionBranch: exists(json, 'selection_branch')
      ? SystemCodeFromJSON(json.selection_branch)
      : defaultSystemCode(),
    orderNumber: exists(json, 'order_number') ? json.order_number : 0,
    callNo: exists(json, 'call_no') ? json.call_no : 0,
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode()
  }
}
